import { Button } from '@/components/primitives/Button';

export function AccountProfileError({ retry }: { retry: () => Promise<void> }) {
  return (
    <main className="jp-stage min-h-screen flex items-center justify-center bg-jp-bg-page px-5">
      <section className="w-full max-w-md rounded-2xl border border-jp-line-edge bg-jp-bg-card p-6 text-jp-fg-primary" role="alert">
        <h1 className="font-jp-display text-2xl font-bold">Your account couldn't load</h1>
        <Button className="mt-6" onClick={() => { void retry(); }}>Try again</Button>
      </section>
    </main>
  );
}
